import { useState, useEffect } from 'react';

const useInputField = ({ value, type }) => {
  const [open, setOpen] = useState(false);
  const [fakeType, setFakeType] = useState(type);
  const [actualValue, setActualValue] = useState(value);

  const [menuEl, setMenuEl] = useState(null);
  const [popperOpen, setPopperOpen] = useState(false);

  const handleOnChangeValue = () => {
    setActualValue(value);
  };

  useEffect(() => setFakeType(type), [type]);
  useEffect(() => handleOnChangeValue, [value]);

  const handleTooltipOpen = () => {
    setOpen(true);
    setTimeout(() => {
      navigator.clipboard.writeText(actualValue);
      setOpen(false);
    }, 500);
  };

  const handleClickShowPassword = () => {
    setFakeType(fakeType === 'password' ? 'text' : 'password');
  };

  const handleOpen = (event) => {
    if (popperOpen) return;
    if (!menuEl) setMenuEl(event.currentTarget);
    setPopperOpen(true);
  };

  const handleClose = () => {
    if (!popperOpen) return;
    setPopperOpen(false);
  };

  const handlePopupIndicator = (event) => {
    if (popperOpen) {
      handleClose();
    } else {
      handleOpen(event);
    }
  };

  const handleInputMouseDown = (event) => {
    if (value === '' || !popperOpen) {
      handlePopupIndicator(event);
    }
  };

  const handleFocus = (event) => {
    handleOpen(event);
  };

  const handleCloseMenu = () => {
    handleClose();
  };

  return {
    open,
    menuEl,
    fakeType,
    popperOpen,
    handleFocus,
    handleInputMouseDown,
    handlePopupIndicator,
    handleCloseMenu,
    handleTooltipOpen,
    handleClickShowPassword,
  };
};

export default useInputField;
